var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ribbon"},_vm._l((_vm.buttons),function(item,index){return _c('app-ribbon-button',{key:index,attrs:{"icon":!!item.icon ? item.icon : 'fa fa-plus'}},[_vm._v("\n        "+_vm._s(item.label)+"\n    ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }